export default {
  deployTrend: {
    title: '部署趋势',
    warning: '告警情况',
    thisMonth: '本月',
    thisWeek: '本周',
    lastMonth: '上月',
    thisYear: '今年',
    lastYear: '去年',
    week1: '周一',
    week2: '周二',
    week3: '周三',
    week4: '周四',
    week5: '周五',
    week6: '周六',
    week7: '周日',
  },
  projectList: {
    title: '项目列表',
    dialog: {
      title: '基本信息',
    },
    table: {
      name: '名称',
      admin: '管理员',
      createTime: '创建时间',
      operation: '操作',
      manage: '管理',
      delete: '删除',
    },
  },
};
